module.exports = __webpack_public_path__ + "img/y_2007_1_hover.91cce1b5.png";